window._ = require('lodash');
window.Popper = require('popper.js').default;

try {
    window.$ = window.jQuery = require('jquery');
    
    require('bootstrap');

    window.toastr = require('toastr');
    require('metismenu');
    
    require('jquery-confirm');
    
    require('select2');
    require('datatables.net-dt');

    require('selectize');

    require('../custom/datepicker/bootstrap-datepicker.js');
    require('../custom/datepicker/bootstrap-datepicker.es.min.js');
    require('../custom/jquery-ui/jquery-ui.js');

    require('../custom/select2/es.js');
    require('blueimp-file-upload/js/jquery.fileupload.js');

    window.moment = require('moment');
    require('moment/locale/es');
    moment.locale('es');
    window.phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance()
    window.PNF = require('google-libphonenumber').PhoneNumberFormat
} catch (e) {
  console.log('Error en librerias');
  console.log(e);
}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */
require('es6-promise').polyfill(); //for IE
window.axios = require('axios');

if(crm.url){
  window.axios.defaults.baseURL =  crm.url;
}
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

if(crm.token){
  window.axios.defaults.headers.common['Authorization'] = `Bearer ${crm.token}`;
  $.ajaxSetup({
    headers: {
        'api_token': crm.token
    }
  });
}

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */
import Echo from 'laravel-echo'
if (!(crm.debug==true || crm.debug==1)) {
  window.Pusher = require('pusher-js');

  window.Echo = new Echo({
    broadcaster: 'pusher',
    key: process.env.MIX_PUSHER_APP_KEY,
    cluster: process.env.MIX_PUSHER_APP_CLUSTER,
    encrypted: true,
    authEndpoint: crm.url+'/broadcasting/auth'
  })
}

/*axios.interceptors.request.use(
    config => {
      config.headers['X-Socket-ID'] = window.Echo.socketId()
      return config
    },
    error => Promise.reject(error)
);*/